import { render } from "./editProfile.vue?vue&type=template&id=3fb5e437&scoped=true"
import script from "./editProfile.vue?vue&type=script&lang=js"
export * from "./editProfile.vue?vue&type=script&lang=js"

import "./editProfile.vue?vue&type=style&index=0&id=3fb5e437&lang=css&scoped=true"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb5e437"]])

export default __exports__